import React, { Component } from 'react';
import { Fstyr } from './Fstyr.js';

type Props = {
    dropDownItems: string[];
    search: (searchType: string, searchString: string) => void;
    showSpinner: boolean;
};

type State = {
    searchString: string
    searchType: string
}

export class FstyrDropdownSearch extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            searchString: "",
            searchType: "",
        };
    }

    search = (): void => { this.props.search(this.state.searchType, this.state.searchString) }

    render() {
        return (
            <div className="fstyr-left-button-group no-margin">
                <Fstyr.Dropdown
                    items={this.props.dropDownItems}
                    autoSelect={true}
                    width={160}
                    onItemSelected={(value: string) => this.setState({ searchType: value }, () => this.search())}
                />
                <input className="form-input"
                    value={this.state.searchString}
                    placeholder={`Søg på ${this.state.searchType}`}
                    onChange={(e) => { this.setState({ searchString: e.target.value }, () => this.search()) }}
                />
                <Fstyr.Button
                    label="Søg"
                    onClick={() => this.search()}
                    disabled={this.props.showSpinner}
                />
                <Fstyr.Spinner
                    show={this.props.showSpinner}
                />
            </div>
        );
    }
}